module.exports = __webpack_public_path__ + "static/hero-a4fd676b54c9d215a04de77ddbaa8507.png";